import React from 'react';
import { Link, useParams } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import {
  getBlogPostBySlugFrom,
  getRelatedPostsFrom,
  useBlogCatalog,
} from '../data/blogCatalog';
import '../styles/BlogPost.css';

function BlogPost() {
  const { slug } = useParams();
  const { posts, loading } = useBlogCatalog();
  const post = getBlogPostBySlugFrom(posts, slug);
  const relatedPosts = getRelatedPostsFrom(posts, slug);

  if (loading && !post) {
    return (
      <div className="blog-post-not-found">
        <div className="not-found-container">
          <h1>Loading…</h1>
          <p>Fetching the latest articles.</p>
        </div>
      </div>
    );
  }

  if (!post) {
    return (
      <div className="blog-post-not-found">
        <div className="not-found-container">
          <h1>Post Not Found</h1>
          <p>The blog post you're looking for doesn't exist.</p>
          <Link to="/blog" className="back-to-blog">← Back to Blog</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="blog-post-page">
      <div className="blog-post-container">
        <div className="back-navigation">
          <Link to="/blog" className="back-to-blog">
            ← Back to Blog
          </Link>
        </div>

        <article className="blog-post-content">
          <header className="post-header">
            <div className="post-meta">
              <span className="post-category">{post.category}</span>
              <span className="post-date">{post.date}</span>
            </div>
            <h1 className="post-title">{post.title}</h1>
            <div className="post-author">
              <span>By {post.author}</span>
            </div>
          </header>

          <div className="post-body">
            <ReactMarkdown>{post.content}</ReactMarkdown>
          </div>

          <div className="post-tags">
            <h4>Tags:</h4>
            <div className="tag-list">
              {(post.tags || []).map((tag, index) => (
                <span key={index} className="tag">
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </article>

        {relatedPosts.length > 0 ? (
          <aside className="related-posts">
            <h3>Related Articles</h3>
            <div className="related-posts-grid">
              {relatedPosts.map((related) => (
                <div key={related.slug} className="related-post-card">
                  <div className="related-post-meta">
                    <span className="related-post-category">{related.category}</span>
                    {related.date ? (
                      <span className="related-post-date">{related.date}</span>
                    ) : null}
                  </div>
                  <h4 className="related-post-title">
                    <Link to={`/blog/${related.slug}`}>{related.title}</Link>
                  </h4>
                  <p className="related-post-excerpt">{related.excerpt}</p>
                  <Link to={`/blog/${related.slug}`} className="read-related-post">
                    Read More →
                  </Link>
                </div>
              ))}
            </div>
          </aside>
        ) : null}
      </div>
    </div>
  );
}

export default BlogPost;
